const Genesis = require("../Genesis.js")
import { post } from "jquery";
import { BlockPageHelper } from "../Helpers/helpers";
import { Modal } from "bootstrap";
import Swal from "sweetalert2";

export class ISiteMobileRecordRecordNotesPage {
    private modal: Modal | null = null;
    public Init() {

        $("#addRecordNotes")
            .click(() => {
            const recordNotesModal = document.getElementById('recordNotesModal');
            if (recordNotesModal !== null) {
              this.modal  = new Modal(recordNotesModal, { backdrop: 'static', keyboard: false });
               this.modal.show();
            }
        });

        $('#recordNote-submitUserMessage')
            .click(() => {
                const form: HTMLFormElement | null = document.querySelector("#recordNoteForm");
                if (form !== null) {
                    if (!form.checkValidity()) {
                        form.classList.add('was-validated');
                        return;
                    }
                    this.saveMessage();
                }
            });
    }

    private saveMessage(): void {
        const type = $('#workorderType option:selected').val();
        const comment = $('#message').val();
        const recordid = $('#RecordId').val();
        BlockPageHelper.block();
        post({
            url: Genesis.url('/Record/SaveRecordNote'),
            data:
            {
                recordId: recordid,
                Note: comment,
                noteTypeId: type === '' ? null : type,
            }
        })
        .then(() => {
            if (this.modal !== null) {
                this.modal.hide();
                window.location.reload();
            }
            BlockPageHelper.unblock();
        }).catch((error) => {
            BlockPageHelper.unblock();
            Swal.fire({ title: "Workorder Error", text: "An error occurred adding notes to the Workorder.  Please try again." });
        });
    }
};